import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateUserGroupV3 = OpalApi<'UpdateUserGroupV3', 200>

export const updateUserGroup: UpdateUserGroupV3 = async (args = {}) => {
  const groupId = args.params?.path.user_group_id

  if (typeof groupId !== 'string') {
    throw new Error('Must supply a valid user_group_id.')
  }

  const url = new URL(
    `/user_groups/v3/user_groups/${groupId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
